import { useParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { getMaterialRoute, TRouteCommon } from '@/_constants/routes';
import { EAnalyticsEvents } from '@/_analytic/_types';
import { getAnalyticsClickAttr } from '@/_analytic/_utils/get-analytics-click-attr/get-analytics-click-attr';
import { COMMON_CHANNELS_ARTICLE_ID } from './_constants';
import { FooterButton } from '../footer-button';

const FooterAllSocialButton = () => {
  const translations = useTranslations('categories.footer');
  const commonButtonText = translations('commonButtonText');

  // todo FooterLink должен быть серверным компонентом
  const { country } = useParams<TRouteCommon>();

  const footerLink = getMaterialRoute({
    country,
    materialId: COMMON_CHANNELS_ARTICLE_ID,
  });

  return (
    <div
      {...getAnalyticsClickAttr({
        name: EAnalyticsEvents.CATEGORIES_FOOTER_CLICK,
        params: { buttonName: commonButtonText },
      })}
    >
      <FooterButton label={commonButtonText} href={footerLink} />
    </div>
  );
};

export default FooterAllSocialButton;
